module.exports = __webpack_public_path__ + "img/mousse.d1c65d3f.png";